import { WizardStep } from "@shared/components/application/navigation/Wizard/WizardStep.web";
import Review from "@app-contexts/public/shared/checkout/components/steps/review/Review.web";
import { useTranslation } from "@shared/utils/internationalization";
import { useState } from "react";
import { usePublicBasket } from "@app-contexts/public/features/basket/services/usePublicBasket";

export const REVIEW_STEP_ID = "review";

export function ReviewStep({
  hideContinueButton,
}: {
  hideContinueButton?: boolean;
}) {
  const { t } = useTranslation("checkout");
  const [isValid, setIsValid] = useState(false);
  const { allRequiredProductPackageSelectionsMade } = usePublicBasket();

  return (
    <WizardStep
      stepId={REVIEW_STEP_ID}
      stepName={t("Review", { ns: "common" })}
      defaultIsValid={false}
      isValid={isValid && allRequiredProductPackageSelectionsMade}
      // Keep mounted so to maintain selected delivery methods
      keepMounted
    >
      <Review
        hideContinueButton={hideContinueButton}
        onSuccess={() => {
          setIsValid(true);
        }}
        onError={() => {
          setIsValid(false);
        }}
      />
    </WizardStep>
  );
}

ReviewStep.id = REVIEW_STEP_ID;
